import { render } from "./xtx-skeleton.vue?vue&type=template&id=18d02bed&scoped=true"
import script from "./xtx-skeleton.vue?vue&type=script&lang=js"
export * from "./xtx-skeleton.vue?vue&type=script&lang=js"

import "./xtx-skeleton.vue?vue&type=style&index=0&id=18d02bed&scoped=true&lang=less"

import exportComponent from "F:\\workspan\\java\\lot\\hk-lottery-lhc-pc-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18d02bed"]])

export default __exports__